import React, {useEffect, useState} from "react";
import { Card } from "../WdCreditCard";
import { useSwipeable } from "react-swipeable";
import { AnimatePresence, motion } from "framer-motion";

export const CardCarrousel = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [direction, setDirection] = useState(0);
    const [width, setWidth] = useState(350);
    const [height, setHeight] = useState(225);
    const [cardConfigurationJson, setCardConfigurationJson] = useState('[]')
    const [cardsCollectionJson, setCardsCollectionJson] = useState('[]')
    const [lang, setLang] = useState('en')
    const [colorCarrousel, setColorCarrousel] = useState('#ED0029')
    const [colorBackground, setColorBackground] = useState('#FFFFFF')


    useEffect(() => {

        window.VTWidgetBridge.Bridge.getAttributes(["vtLang", "vtColorCarrousel", "vtBackgroundColor", "vtCardWidth", "vtCardHeight", "vtCardConfiguration", "vtCardCollections"])
            .defaultValues({
                vtLang: "en",
                vtColorCarrousel: "#000000",
                vtBackgroundColor: "#FFFFFF",
                vtCardWidth: 350,
                vtCardHeight: 225,
                vtCardConfiguration: '{        "hiddenData": "Y",        "bankLogo": "https://vxapp.wfsystems.com.ar/storage/logos/20250630160118.png",        "bankLogoPosition": "bottom-right",        "showBalance": "Y"    }',
                vtCardCollections: '[{        "cuentaId": "7580",        "cardHolder": "Rocio Soledad",        "cardNumber": "**** **** **** 6695",        "cvv": "123",        "colorPrimary": "#967300",        "colorSecondary": "#E2B100",        "brand": "VISA",        "brandPosition": "top-left",        "shape": "ELIPSIS",        "nfc": "Y",        "nfcPosition": "top-right", "balance":1200.12    },{        "cuentaId": "7579",        "cardHolder": "Rocˆ›o Soledad",        "cardNumber": "**** **** **** 0516",        "cvv": "123",        "colorPrimary": "#967300",        "colorSecondary": "#E2B100",        "brand": "VISA",        "brandPosition": "top-left",        "shape": "ELIPSIS",        "nfc": "Y",        "nfcPosition": "top-right", "balance":1300.34    }]'
            })
            .then((attrs) => {
                setLang(attrs.vtLang);
                setColorCarrousel(attrs.vtColorCarrousel);
                setColorBackground(attrs.vtBackgroundColor);
                setWidth(attrs.vtCardWidth);
                setHeight(attrs.vtCardHeight);
                setCardConfigurationJson(attrs.vtCardConfiguration);
                setCardsCollectionJson(attrs.vtCardCollections);
            });
    }, []);

    useEffect(() => {



        window.VTWidgetBridge?.Bridge.raiseEvent?.("vtCardSwipe", {
            vtCurrentBalance: cardsData[currentIndex]?.balance || "0,00",
            vtCuentaId: cardsData[currentIndex]?.cuentaId || "",
        });
    }, [currentIndex]);


    let cardConfiguration = JSON.parse(cardConfigurationJson);

    cardConfiguration ={
        ...cardConfiguration,
        lang:lang
    }

    const cardsData = JSON.parse(cardsCollectionJson).map(card => ({
        ...cardConfiguration,
        ...card
    }));

    const goTo = (newIndex) => {
        if (newIndex >= 0 && newIndex < cardsData.length) {
            setDirection(newIndex > currentIndex ? 1 : -1);
            setCurrentIndex(newIndex);
        }
    };

    const handlers = useSwipeable({
        onSwipedLeft: () => goTo(currentIndex + 1),
        onSwipedRight: () => goTo(currentIndex - 1),
        preventDefaultTouchmoveEvent: true,
        trackMouse: true,
    });

    const variants = {
        enter: (direction) => ({
            x: direction > 0 ? 300 : -300,
            opacity: 0,
            position: "absolute",
        }),
        center: {
            x: 0,
            opacity: 1,
            position: "relative",
        },
        exit: (direction) => ({
            x: direction > 0 ? -300 : 300,
            opacity: 0,
            position: "absolute",
        }),
    };


    return (
        <div className="flex flex-col items-center justify-start w-full min-h-screen pt-10 overflow-hidden" style={{backgroundColor:colorBackground}}>
            {/* Dots */}
            {cardsData.length > 1 && (
                <div className="flex gap-2 mb-6 z-10">
                    {cardsData.map((card, index) => {

                        const active = currentIndex === index;
                        const dotColor = colorCarrousel; // fallback: azul Tailwind

                        return (
                            <div
                                key={index}
                                onClick={() => goTo(index)}
                                className={`rounded-full cursor-pointer transition-all duration-300 ${
                                    active ? "w-4 h-2" : "w-2 h-2 bg-gray-400"
                                }`}
                                style={{
                                    backgroundColor: active ? dotColor : undefined,
                                }}
                            ></div>
                        );
                    })}
                </div>
            )}


            {cardsData.length >= 1 && (

                <div
                    {...handlers}
                    className="relative flex justify-center items-center"
                    style={{ touchAction: "pan-y" }}
                >
                    <AnimatePresence custom={direction} initial={false}>
                        <motion.div
                            key={currentIndex}
                            custom={direction}
                            variants={variants}
                            initial="enter"
                            animate="center"
                            exit="exit"
                            transition={{ duration: 0.3 }}
                            className="w-full h-full"
                        >
                            <Card
                                {...cardsData[currentIndex]}
                                width={width}
                                height={height}
                            />
                        </motion.div>
                    </AnimatePresence>
                </div>
            )}
        </div>
    );
};
